/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP DashBoard  컴포넌트
 *
 ********************************************************************/
import React, { useRef } from "react";
// ex-utils
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//component
import OperationStatus from "./infocards/OperationStatus";
import EhcProgress from "./infocards/EhcProgress";
import EhcStaus from "./infocards/EhcStaus";
import EhcAverageScore from "./infocards/EhcAverageScore";
//import EhcChange from "./infocards/EhcChange";
import OldDeviceStatus from "./infocards/OldDeviceStatus";
import EhcHistory from "./infocards/EhcHistory";
import EhcScore from "./infocards/EhcScore";
import EhcServices from "./infocards/EhcServices";
/**
* @brief EHP DashBoard 개발 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
function DndDashboard(props) {
    //ref, trans
    const mobileRef = useRef(null); // Mobile Check용
    //props
    const selTree = props.selTree;
    const columnList = props.columnList;
    const onParentColumnDragEnd = props.onColumnDragEnd;
    const isDraggable = props.isDraggable;
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "content__dragwrap", ref: mobileRef },
            React.createElement(DragDropContext, { onDragEnd: onParentColumnDragEnd }, columnList.columns.map((column, idx) => ( /*horizontal vertical*/React.createElement(Droppable, { droppableId: idx.toString() /*column.id*/, direction: "horizontal", key: `col_${idx.toString()}` }, (provided, snapshot) => (React.createElement("div", Object.assign({}, provided.droppableProps, { ref: provided.innerRef, className: "content" }),
                column.items.map((item, index) => (React.createElement(InfoCard, { key: `ic1_${index.toString()}`, selTree: selTree, item: item, index: index, isDraggable: isDraggable, colCount: props.colCount }))),
                provided.placeholder)))))))));
}
export default DndDashboard;
function InfoCard(props) {
    //props
    const selTree = props.selTree;
    const item = props.item;
    const index = props.index;
    const isDraggable = props.isDraggable;
    //clog("IN INFOCARD : " + JSON.stringify(item));
    return (React.createElement(React.Fragment, null,
        React.createElement(Draggable, { key: `${item.colId}_${item.id}`, draggableId: `${item.colId}_${item.id}`, index: index, isDragDisabled: !isDraggable }, (provided, snapshot) => (React.createElement("article", Object.assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { className: "box" }), (item.content === "contA") ? React.createElement(OperationStatus, { selTree: selTree, colCount: props.colCount })
            : (item.content === "contB") ? React.createElement(EhcProgress, { selTree: selTree, colCount: props.colCount })
                : (item.content === "contC") ? React.createElement(EhcStaus, { selTree: selTree, colCount: props.colCount })
                    : (item.content === "contD") ? React.createElement(EhcAverageScore, { selTree: selTree, colCount: props.colCount })
                        : (item.content === "contE") ? React.createElement(OldDeviceStatus, { selTree: selTree, colCount: props.colCount })
                            : (item.content === "contF") ? React.createElement(EhcScore, { selTree: selTree, colCount: props.colCount })
                                : (item.content === "contG") ? React.createElement(EhcHistory, { selTree: selTree, colCount: props.colCount })
                                    : (item.content === "contH") ? React.createElement(EhcServices, { selTree: selTree, colCount: props.colCount })
                                        : React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "box__header" },
                                                React.createElement("p", { className: "box__title" },
                                                    "e-HC Status ",
                                                    item.colId,
                                                    " ",
                                                    item.id,
                                                    " / ",
                                                    index % 4),
                                                React.createElement("div", { className: "box__etc" },
                                                    React.createElement("button", { type: "button", className: "btn btn-setting toggle" },
                                                        React.createElement("span", { className: "hide" }, "\uC810\uAC80\uC8FC\uAE30 \uC124\uC815")))),
                                            React.createElement("div", { className: "box__body", style: { "fontSize": "200px" } }, item.id)))))));
}
